import { ReactNode } from 'react';
import styles from './ActivityFeedModal.module.scss';
import { Modal } from 'components';

type Props = {
  onClose(): void;
  children: ReactNode;
};

export const ActivityFeedModal = ({ onClose, children }: Props) => {
  return (
    <Modal
      title="All notifications"
      onClose={onClose}
      type="bottom"
      closeOnBackdrop={true}
      darkerBackground={true}
      contentContainerElementId={styles.modalContentContainerElementId}>
      {children}
    </Modal>
  );
};
